import { render, staticRenderFns } from "./diapositiva-3.vue?vue&type=template&id=153cd3bb&scoped=true&"
import script from "./diapositiva-3.vue?vue&type=script&lang=js&"
export * from "./diapositiva-3.vue?vue&type=script&lang=js&"
import style0 from "./diapositiva-3.vue?vue&type=style&index=0&id=153cd3bb&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "153cd3bb",
  null
  
)

export default component.exports